import { Controller } from "@hotwired/stimulus"
import { api } from "../services/api";

export default class extends Controller {
  private requestSeq = 0

  static targets = [ "contractSelect", "summary" ]
  static values = {
    summaryPath: String
  }

  declare readonly contractSelectTarget: HTMLSelectElement;
  declare readonly summaryTarget: HTMLElement;
  declare readonly summaryPathValue: string;

  async update() {
    const seq = ++this.requestSeq

    try {
      const { data } = await api.axiosClient.get(this.summaryPathValue, {
        params: { contract_id: this.contractSelectTarget.value || undefined },
        headers: { Accept: "text/html" },
        responseType: "text"
      });

      if (seq !== this.requestSeq) return
      this.summaryTarget.innerHTML = data;
    } catch (error) {
      if (seq !== this.requestSeq) return
      console.error(error);
    }
  }
}
